var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useMergedRef } from '../_internal/useMergedRef';
import { useHasColoredBackground } from '../useHasColoredBackground';
import { withLabel } from '../withLabel';
import { IconButton, Input, InputContainer, Line, SideElementContainer, } from './TextInput.style';
var InnerTextInput = React.forwardRef(function (props, ref) {
    var _a = props.small, small = _a === void 0 ? false : _a, _b = props.error, error = _b === void 0 ? false : _b, 
    // eslint-disable-next-line deprecation/deprecation
    _c = props.light, 
    // eslint-disable-next-line deprecation/deprecation
    light = _c === void 0 ? false : _c, _d = props.bare, bare = _d === void 0 ? false : _d, className = props.className, style = props.style, elementRight = props.elementRight, elementLeft = props.elementLeft, containerRef = props.containerRef, canReset = props.canReset, value = props.value, disabled = props.disabled, rest = __rest(props, ["small", "error", "light", "bare", "className", "style", "elementRight", "elementLeft", "containerRef", "canReset", "value", "disabled"]);
    var hasBackground = useHasColoredBackground();
    var inputRef = useMergedRef(ref);
    return (React.createElement(InputContainer, { className: className, style: style, "data-error": error, "data-small": small, "data-light": light, "data-bare": bare, "data-background": hasBackground, "data-disabled": disabled, ref: containerRef, onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, onTouchStart: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } },
        elementLeft && (React.createElement(SideElementContainer, { "data-position": "left" }, elementLeft)),
        React.createElement(Input, __assign({ value: value !== null && value !== void 0 ? value : '', disabled: disabled }, rest, { ref: inputRef })),
        (elementRight || canReset) && (React.createElement(SideElementContainer, { "data-position": "right" },
            canReset && value && "".concat(value).length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(IconButton, { icon: "close", onClick: function (e) {
                        var _a;
                        return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, {
                            target: __assign(__assign({}, e.target), { value: '' }),
                        });
                    } }),
                elementRight && React.createElement(Line, null))),
            elementRight))));
});
export var TextInput = withLabel({
    orientation: 'vertical',
})(InnerTextInput);
//# sourceMappingURL=TextInput.js.map